import config from '@/config';

export function generateBankAccountSelectionCallbackUrl(origin: string) {
  return `${config.rocker.payoutSelectionCallbackUrl}?origin=${encodeURIComponent(origin)}`;
}
